<template>
  <div>
    <button v-if="displayNextPage" class="milkyBlock pagination pull-right paginationNumber" @click="pagination(currentPage+1)">
      <f7-icon f7="chevron_right" style="font-size: 14px;"></f7-icon>
    </button>
    <div v-if="displayNextPage || displayPreviousPage" class="milkyBlock pagination pull-right">
      <span>{{currentPage}}</span>
    </div>
    <button v-if="displayPreviousPage" class="milkyBlock pagination pull-right paginationNumber"  @click="pagination(currentPage-1)">
      <f7-icon f7="chevron_left" style="font-size: 14px;"></f7-icon>
    </button>
  </div>
</template>

<script>
/** @author ARO - TLV 2020
* @brief Component qui gère toutes les paginations sur MoneyRoad
* @param maxResultsByPage est le nombre de résultats maximum sur une page
* @param firstIndex correspond à l'indice de la première demande de la page sélectionnée
* @param nbResultsTotal correspond au total de résultats sur toutes les pages
* @param refreshEvent correspond à l'événement du bus à appeler lors d'un passage à une autre page
*/
export default {
  name: 'Pagination',
  props: ['maxResultsByPage', 'firstIndex', 'nbResultsTotal', 'refreshEvent'],
  methods: {
    pagination (nb) {
      let newFirstIndex = (nb - 1) * this.maxResultsByPage + 1
      this.$bus.$emit(this.refreshEvent, newFirstIndex)
    }
  },
  /** @author TLV 02/04/2020
  * Remplacement du bus par des propriétés calculées pour gérer deux paginations sur une même page
  * (ce que ne permet pas vraiment le bus)
  * La page suivante est affichée si on n'est pas sur la dernière,
  * La page précédente est affichée sauf si on est sur la page 1 */
  computed: {
    currentPage () {
      return (((this.firstIndex - 1) / this.maxResultsByPage) + 1)
    },
    /** @author ARO - TLV 2020
    * @brief Propriétée calculée qui vérifie si on affiche la page suivante ou non
    * @details Si le nombre de données affichées aux pages précédentes + le nombre
    *           max de données autorisées à être affichées sur cette page est
    *           toujours inférieur au nombre total de données retournées par la modé,
    *           alors on affiche le bouton pour passer à la page suivante
    */
    displayNextPage () {
      return (this.firstIndex + this.maxResultsByPage - 1 < this.nbResultsTotal)
    },
    displayPreviousPage () {
      return (this.firstIndex !== 1)
    }
  }
}
</script>
<style>
.paginationNumber {
  margin-top: 13px;
}
</style>



// WEBPACK FOOTER //
// pagination.vue?c7130064